var Bloc = require('./Bloc');
//var Types = require('./Types');
//var Listener = require('../Listener');

class Frenzy extends Bloc {

	constructor (src, ctx) {

		super("frenzy", src, ctx, true);
		this.f = (src, ins) => [this, this.victim];
		this.types = [];
		this.out = [this, null];
	}

	setup (owner, image) {

		owner.frenzy = true;
		/*var that = this;
		owner.passives.push(new Listener(owner, () => that.src.gameboard.subscribe("damagecard", (t,s,d) => {
			if (d[1] === owner && owner.onBoard && s.chp !== undefined && s.chp <= 0) {
				that.victim = s;
				that.unsubVictim = that.src.gameboard.subscribe("destroycard", (t2,s2,d2) => {
					if (that.victim === s2) {
						that.execute({src: owner, image: image});
						that.unsubVictim();
					}
				});
			}
		})));*/
	}
}

module.exports = Frenzy;


// WEBPACK FOOTER //
// ./src/game/model/blueprint/Frenzy.js